export default __webpack_public_path__ + "static/media/bg_main_home.c7b38cec.jpg";